<template>
  <div
    v-if="attributes"
    class="product-attributes-fi"
  >
    <div
      v-for="(attribute, idx) in attributes"
      :key="attribute.AttributeKey || ''"
      :class="{
        [`attribute--${idx}`]: true,
        'product-attributes-fi__item': true,
        'product-attributes-fi__item--icon': attribute.Value === 'relevant',
      }"
    >
      <span v-if="attribute.ValueList?.length">
        {{ attribute.ValueList.join(', ') }}
      </span>
      <template v-else-if="attribute?.Value">
        <template v-if="attribute.Value === 'relevant'">
          <icon-fi
            class="product-attributes-fi__icon"
            icon="check"
          />
        </template>
        <template v-else>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-html="attribute.Value" />
        </template>
        <template v-if="attribute.Unit">
          <!-- eslint-disable vue/no-v-html -->
          <span
            class="product-attributes-fi__item__unit"
            v-html="attribute.Unit"
          />
          <!-- eslint-enable vue/no-v-html -->
        </template>
      </template>
      <template v-else> &#8212; </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IconFi } from 'atoms';

interface ProductAttribute {
  AttributeKey?: string | null;
  Value?: string | null;
  Unit?: string | null;
  ValueList?: string[] | null;
}

defineOptions({ name: 'ProductAttributesFi' });

defineProps<{
  attributes: ProductAttribute[];
}>();
</script>

<style scoped src="./product-attributes-fi" />
